import { render, staticRenderFns } from "./printchailvfei.vue?vue&type=template&id=05ef6404&scoped=true&"
import script from "./printchailvfei.vue?vue&type=script&lang=js&"
export * from "./printchailvfei.vue?vue&type=script&lang=js&"
import style0 from "./printchailvfei.vue?vue&type=style&index=0&id=05ef6404&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ef6404",
  null
  
)

export default component.exports